import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { TeamConfigurationPageComponent } from "./team-configuration-page.component";

export const teamConfigurationPageRoute = new OrganisationPageRouteBuilder<{ teamId: number }>()
    .usingNgComponent("adapt-team-configuration-page", TeamConfigurationPageComponent)
    .atOrganisationUrl("/team/:teamId/configuration")
    .withTitle("Configure Team")
    .withSearchKeyword("Configuration")
    .build();
